import React from 'react'
import url from 'front-end-core/core/url'
import { CURRENT_AWARENESS } from 'constants/controllers'
import CAQuickDatePickers from 'components/search/CAQuickDatePickers'
import SearchFiltersContainer from 'redux/containers/pages/currentawareness/SearchFiltersContainer'
import { useSelector } from 'react-redux'
import dayjs from 'dayjs'
import { pushEvent } from 'services/AnalyticsService'
import { replaceUrl } from 'front-end-core/core/history'
import CalenderDatePickers from 'components/shared/calender-date-pickers'
import useDatePicker from 'hooks/useDatePicker'
import selectAolName from 'redux/selectors/selectAolName'

dayjs.locale('en')

const Filters = (props) => !props.searchPhrase
  ? <BrowseFilters {...props} />
  : <SearchFiltersContainer {...props} />

const submitDates = (fromDate, toDate, aol) => {
  const getUrl = () => url(CURRENT_AWARENESS, { aol, fromDate, toDate })
  pushEvent({ category: 'Current Awareness', action: 'Filter', label: `Date range from ${fromDate} to ${toDate}` })
  replaceUrl(getUrl())
}

const BrowseFilters = ({ fromDate, toDate }) => {
  const datePicker = useDatePicker(fromDate, toDate)
  const aol = useSelector(selectAolName)
  const onHandleButtonSubmit = () => submitDates(datePicker.fromDateSelected, datePicker.toDateSelected, aol)

  return (
    <div className='ph6 ph4-t pb10'>
      <div data-help-item='caquicklinks' data-help-position='middle'>
        <CAQuickDatePickers
          fromDate={fromDate}
          toDate={toDate}
          getUrl={compare => url(CURRENT_AWARENESS, { aol, ...compare })}
        />
      </div>
      <CalenderDatePickers {...{ ...datePicker, onHandleButtonSubmit, theme: 'ca' }} />
    </div>
  )
}

export default Filters
